export class FiltroListagemBilhetesComPrevisao {
 
    public consumidorId: number;
 
    public tipoSorteio: number;
 
    public ano: number;
   
    public mes: number;
 
    public page: number;
 
    public pageSize: number;
}


// WEBPACK FOOTER //
// ./src/app/shared/model/filtro-listagem-bilhetes-com-previsao.ts